import { Order } from "../features/order/Order";

export default function OrderSuccessPage() {
  return <Order />;
}
